import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.echomemoir.ai/api';

const registerTokenWithServer = async (fcmTokenValue, authToken) => {
  const platform = window.Capacitor.getPlatform();
  
  try {
    await axios.post(`${API_URL}/push/register`, {
      token: fcmTokenValue,
      platform
    }, {
      headers: { Authorization: `Bearer ${authToken}` }
    });
    console.log('🔔 Push token registered with server (' + platform + '): ' + fcmTokenValue.substring(0, 30) + '...');
    return true;
  } catch (error) {
    console.error('Failed to register push token:', error);
    return false;
  }
};

export const usePushNotifications = () => {
  const { isAuthenticated } = useAuth();
  const registeredRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || registeredRef.current) return;

    const token = localStorage.getItem('token');
    if (!token) return;

    const setupPush = async () => {
      if (!window.Capacitor?.isNativePlatform()) return;

      try {
        const { FirebaseMessaging } = await import('@capacitor-firebase/messaging');
        
        // Request permission
        const permResult = await FirebaseMessaging.requestPermissions();
        if (permResult.receive !== 'granted') {
          console.log('Push notification permission denied');
          return;
        }

        // Get the FCM token directly (works on both iOS and Android)
        const { token: fcmToken } = await FirebaseMessaging.getToken();
        console.log('🔔 FCM token:', fcmToken);
        
        if (fcmToken) {
          const success = await registerTokenWithServer(fcmToken, token);
          if (success) registeredRef.current = true;
        }

        // Listen for token refresh
        FirebaseMessaging.addListener('tokenReceived', async (event) => {
          console.log('🔔 FCM token refreshed:', event.token);
          if (!registeredRef.current) {
            const success = await registerTokenWithServer(event.token, token);
            if (success) registeredRef.current = true;
          }
        });

        // Handle foreground notifications
        FirebaseMessaging.addListener('notificationReceived', (notification) => {
          console.log('🔔 Push received (foreground):', notification);
        });

        // Handle notification tap (app was in background)
        FirebaseMessaging.addListener('notificationActionPerformed', (action) => {
          console.log('🔔 Push tapped:', action);
          const data = action.notification?.data;
          
          if (data?.type === 'new_story' && data?.storyId) {
            window.location.href = `/story/${data.storyId}`;
          } else if (data?.type === 'new_comment' && data?.storyId) {
            window.location.href = `/story/${data.storyId}`;
          } else if ((data?.type === 'member_joined' || data?.type === 'invite_accepted') && data?.circleId) {
            window.location.href = `/family/${data.circleId}`;
          }
        });

      } catch (error) {
        console.error('Push notification setup error:', error);
      }
    };

    setupPush();
  }, [isAuthenticated]);
};